// ComposerMenuPortal — portala os drop-ups do composer (#chat / @file / /skill /
// @menu) pra FORA do `.rx-composer`. Motivo (Pedro 2026-07-07): o composer tem
// `backdrop-filter` (redesign.css), que cria um stacking context PRÓPRIO — os
// menus, filhos dele, ficavam presos nesse contexto e apareciam ATRÁS do
// composer / do chrome ao redor. No `document.body`, com `position:fixed`
// ancorado na textarea, os menus pintam acima de todo o app (z alto), sem
// depender do empilhamento local. Zero-height: os filhos usam `bottom-full` e
// sobem a partir do topo da textarea, exatamente como antes.

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function ComposerMenuPortal({ anchorRef, children }) {
  const [rect, setRect] = useState(null);

  useEffect(() => {
    const el = anchorRef?.current;
    if (!el || typeof window === 'undefined') return undefined;
    const measure = () => {
      const r = el.getBoundingClientRect();
      setRect({ left: r.left, top: r.top, width: r.width });
    };
    measure();
    // ResizeObserver pega o crescimento da textarea (rows/resize-y); scroll em
    // CAPTURE pega o scroll interno do feed; resize pega a janela.
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    ro?.observe(el);
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, true);
    return () => {
      ro?.disconnect();
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
    };
  }, [anchorRef]);

  if (!rect || typeof document === 'undefined') return null;

  return createPortal(
    <div
      style={{ position: 'fixed', left: rect.left, top: rect.top, width: rect.width, height: 0, zIndex: 60 }}
      data-composer-menu-portal=""
    >
      {children}
    </div>,
    document.body,
  );
}
